import React, { memo } from "react";
import { useAppState } from "../RetailerFitGuide_StateContext.jsx";
import { Link } from "react-router-dom";

export const RetailerFitGuide_ClearCar = memo(({ link, clearEvent }) => {
    const {
        clearSettings,
        translations,
    } = useAppState();

    const doClear = () => {
        if (clearEvent) {
            clearEvent();
        } else {
            clearSettings();
        }
    }
    return link ? <Link className="retailerFitGuide_ClearCar paragraph--xs" to={link}>{translations.clearAllCarInfo}</Link> : <button onClick={doClear} className="retailerFitGuide_ClearCar paragraph--xs">
        {translations.clearAllCarInfo}
    </button>
});